<template>
    <v-container fluid class="superTable pa-0">
        <v-row no-gutters align="center">
            <v-col sm="4">
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" :placeholder="$t('actions.search')" outlined
                    clearable class="superTable__search" @keyup="keyup" @keyup.esc="search = ''"></v-text-field>
            </v-col>
            <v-col sm="8" class="text-right">
                <label>
                    Mostrar Solo Activas:
                    <input type="checkbox" v-model="showActive" />
                </label>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col sm="12">
                <v-data-table :show-select="true" :headers="headers" :items="filteredData" :search="search"
                    :page.sync="page" :items-per-page="itemsPerPage" v-model="selectedItems" hide-default-footer
                    :server-items-length="serverSide ? totalItems : undefined"
                    item-key="id" class="superTable__table studentSubjectStatusTable" style="table-layout: fixed">
                    <template v-slot:[`item.action`]="{ item }">
                        <v-menu bottom left>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" class="superTable__table__item__action">mdi-dots-vertical</v-icon>
                            </template>
                            <v-list class="pa-0">
                                <v-list-item v-if="item.subjectStatusCode == pending" @click="setStatusOngoing(item)">
                                    <v-list-item-title>
                                        <v-icon>mdi-pencil</v-icon> {{ 'Avanzar a en curso' }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="item.subjectStatusCode == canceled" @click="setStatusPending(item)">
                                    <v-list-item-title>
                                        <v-icon>mdi-pencil</v-icon> {{ 'Volver a pendiente' }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="(item.subjectStatusCode == ongoing || item.subjectStatusCode == reproved)"
                                    @click="setStatusApproved(item)">
                                    <v-list-item-title>
                                        <v-icon>mdi-pencil</v-icon> {{ 'Aprobar materia' }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="item.subjectStatusCode == ongoing || item.subjectStatusCode == approved"
                                    @click="setStatusReproved(item)">
                                    <v-list-item-title>
                                        <v-icon>mdi-pencil</v-icon> {{ 'Desaprobar materia' }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="item.subjectStatusCode != canceled" @click="setStatusCanceled(item)">
                                    <v-list-item-title>
                                        <v-icon>mdi-pencil</v-icon> {{ 'Anular materia' }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title @click="setFinalNote(item)">
                                        <v-icon>mdi-pencil</v-icon> {{ 'Cambiar nota' }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
                <v-divider class="mt-4 mb-8"></v-divider>
            </v-col>
        </v-row>
        <v-row no-gutters class="pb-4">
            <v-col sm="6"></v-col>
            <v-col>
                <v-btn @click="approveSelected" :disabled="!hasSelectedItems()">Aprobar Seleccionadas</v-btn>
            </v-col>
            <v-col>
                <v-btn @click="reproveSelected" :disabled="!hasSelectedItems()">Reprobar Seleccionadas</v-btn>
            </v-col>
        </v-row>
        <v-row no-gutters align="center">
            <v-col sm="3">
                <span class="caption d-inline-block">{{ itemsCount.startItem + ' - ' + itemsCount.endItem + ' de ' +
                    itemsCount.totalItems }}</span>
                <v-select v-model="itemsPerPage" :items="itemsPerPageAvailable" :placeholder="`${itemsPerPage}`" outlined
                    class="superTable__paginationSelect d-inline-block ml-4"></v-select>
            </v-col>
            <v-col sm="6" class="text-center">
                <v-pagination v-model="page" :length="pageCount" class="superTable__pagination"></v-pagination>
            </v-col>
            <v-col sm="3" align="right">
                <v-text-field v-model="page" max="pageCount" outlined
                    class="superTable__paginationInput d-inline-block mr-4"></v-text-field>
                <span class="caption d-inline-block">{{ $t('modules.communities.table.goToPage') }}</span>
            </v-col>
        </v-row>
        <v-dialog v-model="showModal" max-width="400">
            <v-card class="pa-5">
                <v-card-title>{{ (actionToConfirm == 'approve') ? 'Aprobar seleccionadas' : 'Desaprobar seleccionadas'
                }}</v-card-title>
                <v-card-text>
                    Esta acción modificará el estado de todas las materias seleccionadas.
                    <br>
                    ¿Está seguro de que desea continuar?
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="confirmAction">OK</v-btn>
                    <v-btn @click="cancelAction">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: 'SuperTable',
    props: {
        data: Array,
        headers: Array,
        serverSide: {
            type: Boolean,
            default: false,
        },
        totalItems: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            search: '',
            timeout: null,
            page: 1,
            itemsPerPage: 20,
            itemsPerPageAvailable: [20, 50, 100, 200],
            showActive: false,
            pending: 683,
            ongoing: 86,
            approved: 84,
            reproved: 87,
            canceled: 119,
            selectedItems: [],
            showModal: false,
            selectedIdsToConfirm: [],
            actionToConfirm: '',
        }
    },
    mounted() {
        this.$emit('searchAction', this.search)
    },
    methods: {
        keyup() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.searchAction()
                clearTimeout(this.timeout);
            }, 1000)
        },
        searchAction() {
            this.$emit('searchAction', this.search)
        },
        setStatusOngoing(item) {
            this.$emit('setStatusOngoing', item)
        },
        setStatusApproved(item) {
            this.$emit('setStatusApproved', item)
        },
        setStatusReproved(item) {
            this.$emit('setStatusReproved', item)
        },
        setStatusCanceled(item) {
            this.$emit('setStatusCanceled', item)
        },
        setFinalNote(item) {
            this.$emit('setFinalNote', item)
        },
        setStatusPending(item) {
            this.$emit('setStatusPending', item)
        },
        hasSelectedItems() {
            return this.selectedItems.length > 0;
        },
        approveSelected() {
            const selectedIds = this.selectedItems.map(item => item.id);
            this.selectedIdsToConfirm = selectedIds;
            this.actionToConfirm = 'approve';
            this.showModal = true;
        },
        reproveSelected() {
            const selectedIds = this.selectedItems.map(item => item.id);
            this.selectedIdsToConfirm = selectedIds;
            this.actionToConfirm = 'reprove';
            this.showModal = true;
        },
        confirmAction() {
            if (this.actionToConfirm === 'approve') {
                this.$emit('approveSelected', this.selectedIdsToConfirm);
            } else {
                this.$emit('reproveSelected', this.selectedIdsToConfirm);
            }
            this.showModal = false;
            this.selectedIdsToConfirm = [];
        },
        cancelAction() {
            this.showModal = false;
            this.selectedIdsToConfirm = [];
        },
    },
    watch: {
        page(val) {
            if (this.serverSide) {
                this.$emit('update:options', { page: val, itemsPerPage: this.itemsPerPage });
            } else {
                if (val > this.pageCount) this.page = this.pageCount;
                if (val <= 1) this.page = 1;
            }
        },
        options: {
            handler() {
                if (this.serverSide) {
                    this.$emit('update:options', { page: this.page, itemsPerPage: this.itemsPerPage });
                }
            },
            deep: true,
        },
        itemsPerPage(val) {
            if (this.serverSide) {
                this.$emit('update:options', { page: this.page, itemsPerPage: val });
            }
        },

    },
    computed: {
        filteredData() {
            if (this.showActive) {
                return this.data.filter(item => item.subjectStatusCode == this.ongoing)
            }
            return this.data
        },
        pageCount() {
            const total = this.serverSide ? this.totalItems : this.data.length;
            let counter = total / this.itemsPerPage;
            if (counter < 1) counter = 1
            return Math.ceil(counter)
        },
        itemsCount() {
            if (this.serverSide) {
                return {
                    totalItems: this.totalItems,
                    startItem: ((this.page * this.itemsPerPage) - this.itemsPerPage) + 1,
                    endItem: Math.min(this.page * this.itemsPerPage, this.totalItems)
                }
            }
            const counter = {
                totalItems: this.data.length,
                startItem: ((this.page * this.itemsPerPage) - this.itemsPerPage) + 1,
                endItem: this.page * this.itemsPerPage
            }
            if (counter.endItem > this.data.length) counter.endItem = this.data.length
            return counter
        }
    },
};
</script>

<style lang="sass">
    .subjectsStudyPlanTable table tbody tr
        cursor: pointer
</style>